export default [
  // 课程管理
  {
    path: '/xiaoxiong/:courseID',
    component: () => import('@/views/pages/xiaoxiong/index'),
    redirect: '/xiaoxiong/:courseID/statistic',
    children: [
      {
        path: 'students',
        meta: { title: "学生管理" },
        component: () => import('@/views/pages/xiaoxiong/students/index.vue'),
        redirect: '/xiaoxiong/:courseID/students',
        children: [
          {
            path: '',
            name: 'empty',
            meta: { title: "学生管理" },
            component: () => import('@/views/pages/xiaoxiong/students/empty.vue'),
          },
          {
            path: ':userID',
            name: 'student',
            meta: { title: "学生管理" },
            component: () => import('@/views/pages/xiaoxiong/students/student.vue'),
          },
          {
            path: ':userID/:chapterID',
            name: 'student',
            meta: { title: "学生管理" },
            component: () => import('@/views/pages/xiaoxiong/students/student.vue'),
          }
        ]
      },
    ]
  }
]